import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import queryString from 'query-string';

type Props = {
  className?: string;
};

export const ContactForm: React.FC<Props> = props => {
  let history = useHistory();
  const location = useLocation();
  const [existingEmail, setExistingEmail] = useState<string>('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [company, setCompany] = useState('');
  useEffect(() => {
    const params = queryString.parse(location.search);
    if (params !== undefined) {
      let email: string = Array.isArray(params.email)
        ? params.email[0]
        : params.email;
      setExistingEmail(email);
    }
  }, []);
  return (
    <div className={`relative bg-white rounded-lg ${props.className}`}>
      <div className="absolute inset-0 ">
        <div className="absolute  inset-y-0 left-0 w-1/2 bg-gray-100" />
      </div>
      <div className="relative max-w-7xl mx-auto lg:grid lg:grid-cols-5 lg:items-center lg:gap-x-6">
        <div className="bg-gray-100  py-16  lg:col-span-2  xl:pr-12">
          <div className="max-w-lg mx-auto">
            <h2 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">
              Get in touch
            </h2>
            <p className="mt-3 text-lg leading-6 text-gray-500 mt-4">
              We're eager to hear from you. Let us know how we can help and we
              promise to do our very best.
            </p>
            <dl className="mt-8 text-base text-gray-500">
              <div className="mt-6">
                <dt className="sr-only">Phone number</dt>
                <dd className="flex">
                  <svg
                    className="flex-shrink-0 h-6 w-6 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  <a
                    href="tel:+1-415-741-0052"
                    className="ml-3 text-gray-900 hover:text-primary-600 tracking-tighter"
                  >
                    +1 (415) 741 0052
                  </a>
                </dd>
              </div>
              <div className="mt-3">
                <dt className="sr-only">Email</dt>
                <dd className="flex">
                  <svg
                    className="flex-shrink-0 h-6 w-6 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <a
                    href="mailto: contact@tabletab.io"
                    target="_blank"
                    className="ml-3 text-gray-900 hover:text-primary-600"
                  >
                    contact@tabletab.io
                  </a>
                </dd>
              </div>
            </dl>
            {/*<p className="mt-6 text-base text-gray-500">*/}
            {/*    Looking for careers?*/}
            {/*    <a href="#" className="font-medium text-gray-700 underline">View all job openings</a>.*/}
            {/*</p>*/}
          </div>
        </div>
        <div className="bg-white shadow-xl rounded-lg py-16 px-4 sm:px-6 lg:col-span-3 lg:py-24 lg:px-8 xl:pl-12">
          <div className="max-w-lg mx-auto lg:max-w-none">
            <form
              onSubmit={e => {
                e.preventDefault();
                // @ts-ignore
                window.analytics.identify({
                  email: existingEmail,
                  firstName: name,
                  phone: phone,
                  company: company,
                  restaurant: company,
                  fullName: name,
                });
                return history.push('/thankyou');
              }}
              className="grid grid-cols-1 gap-y-6"
              id={'contact_form_wv2'}
            >
              <div>
                <label htmlFor="email" className="sr-only">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required={true}
                  className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-primary-200 focus:border-primary-200 border-gray-300 rounded-xl"
                  placeholder="Email"
                  value={existingEmail}
                  onChange={e => {
                    setExistingEmail(e.target.value);
                  }}
                />
              </div>
              <div>
                <label htmlFor="full_name" className="sr-only">
                  Name
                </label>
                <input
                  type="text"
                  name="full_name"
                  id="full_name"
                  autoComplete="name"
                  required={true}
                  onChange={e => {
                    e.preventDefault();
                    setName(e.target.value);
                  }}
                  className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-primary-200 focus:border-primary-200 border-gray-300 rounded-xl"
                  placeholder="Name"
                />
              </div>
              <div>
                <label htmlFor="full_name" className="sr-only">
                  Restaurant
                </label>
                <input
                  type="text"
                  name="restaurant"
                  id="restaurant"
                  autoComplete="organization"
                  required={true}
                  onChange={e => {
                    e.preventDefault();
                    setCompany(e.target.value);
                  }}
                  className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-primary-200 focus:border-primary-200 border-gray-300 rounded-xl"
                  placeholder="Company"
                />
              </div>
              <div>
                <label htmlFor="phone" className="sr-only">
                  Phone
                </label>
                <input
                  type="text"
                  name="phone"
                  id="phone"
                  autoComplete="tel"
                  required={true}
                  onChange={e => {
                    e.preventDefault();
                    setPhone(e.target.value);
                  }}
                  className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-primary-200 focus:border-primary-200 border-gray-300 rounded-xl"
                  placeholder="Phone"
                />
              </div>
              {/* <div>
                <label htmlFor="message" className="sr-only">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-primary-200 focus:border-primary-200 border-gray-300 rounded-xl"
                  placeholder="Message"
                />
              </div> */}
              <div>
                <button
                  type="submit"
                  className="pl-10 pr-10 inline-flex justify-center py-3 px-6 border border-transparent shadow-sm text-base font-medium rounded-full text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 hover:text-white focus:text-white"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
